module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp123_8017.361a735e.png";